import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { bindActionCreators } from 'redux';
import { isEmpty } from 'lodash';

import api from 'core/utils/api';
import DuplicateTestForm from './DuplicateTestForm';
import { success as notifySuccess } from 'components/ui/Notify/store/actions';
import { getDevice, fetchDevice, isFetching } from 'store/deviceReducer';
import Spin from 'components/ui/Spin';

const propTypes = {
  deviceType: PropTypes.string.isRequired,
};

class DuplicateTestNewContainer extends React.Component {
  constructor(props) {
    super(props);

    const { deviceId } = queryString.parse(this.props.location.search);
    if (!deviceId) { return; }
    this.props.fetchDevice(deviceId);
  }

  handleSubmit = (values, setSubmitting) => {
    const { notifySuccess, history, deviceType } = this.props;

    api
      .post('/duplicate_tests', { duplicate_test: values })
      .then(() => {
        setSubmitting(false);
        notifySuccess('Duplicate test successfully created.');
        history.push(`/qa/${deviceType}/duplicates`);
      });
  }

  render() {
    const { device, isFetching, deviceType } = this.props;
    const initialValues = {
      test_type: deviceType,
      result1: '',
      result2: '',
      tested_at: new Date(),
    };

    if (isFetching) { return <Spin /> };

    if (!isEmpty(device)) {
      Object.assign(initialValues, {
        device1_id: device.id,
        device1: device,
      });
    }

    return (
      <DuplicateTestForm
        initialValues={initialValues}
        onSubmit={this.handleSubmit}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { deviceId } = queryString.parse(ownProps.location.search);
  return {
    device: getDevice(state, deviceId),
    isFetching: isFetching(state),
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators({
    fetchDevice,
    notifySuccess,
  }, dispatch);
};

DuplicateTestNewContainer.propTypes = propTypes;

export default connect(mapStateToProps, mapDispatchToProps)(DuplicateTestNewContainer);



// WEBPACK FOOTER //
// ./src/features/qa/DuplicateTestNewContainer.js